import { render, staticRenderFns } from "./DisplayStatusValue.vue?vue&type=template&id=23c457e5&scoped=true&"
import script from "./DisplayStatusValue.vue?vue&type=script&lang=js&"
export * from "./DisplayStatusValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c457e5",
  null
  
)

export default component.exports